import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=20e5923f&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=ts"
export * from "./Spinner.vue?vue&type=script&lang=ts"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=20e5923f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e5923f",
  null
  
)

export default component.exports